import { JUMP_BUFFER_TIME } from '@modules/feedback/components/AudioType/AudioFeedbackPlayer/AudioFeedbackPlayer';
import { getCurrentPlayingHighlight } from '@modules/feedback/components/AudioType/utils';
import { getHighlightMetadata } from '@modules/feedback/utils/getHighlightMetadata';
import { Feedback, FeedbackLabel } from 'v2/core/entities/feedback';

interface GetSnippetShareUrlOptions {
  feedback: Feedback;
  selectedLabels: FeedbackLabel[];
  startTime: number;
  endTime: number;
  tenantSlug?: string;
}

export const getSnippetShareUrl = ({
  feedback,
  selectedLabels,
  startTime,
  endTime,
  tenantSlug,
}: GetSnippetShareUrlOptions) => {
  const metadata = getHighlightMetadata({
    feedback,
    selectedLabels,
  });

  const currentShareSnippetHighlight = getCurrentPlayingHighlight(
    metadata,
    startTime,
    JUMP_BUFFER_TIME,
  );

  return `${window.location.origin}/${tenantSlug}/record/${
    feedback.id
  }?start=${startTime}&end=${endTime}${
    currentShareSnippetHighlight
      ? `&labelID=${currentShareSnippetHighlight.labelID}`
      : ''
  }`;
};
